<ng-container>

  <!-- 1. Template DropdownButton -->
  @if (dropdownButtonTemplate) {
    <ng-container *ngTemplateOutlet="dropdownButtonTemplate.tempRef; context: dropdownButtonTemplate?.tempContext" />
  } @else {
    <ng-content select="[appDropdownButtons]">
      <ng-container *ngTemplateOutlet="defaultDropdownButtonsTpl" />
    </ng-content>
  }

  <!-- 2. Projected or fallback DropdownButtons -->

  <!-- 1. Template DropdownMenu -->
  @if (dropdownMenuTemplate) {
    <ng-container *ngTemplateOutlet="dropdownMenuTemplate.tempRef; context: dropdownMenuTemplate?.tempContext" />
  } @else {
    <ng-content select="[dropdownMenu]">
      <ng-container *ngTemplateOutlet="defaultDropdownMenuTpl; context: { items }" />
    </ng-content>
  }

  <!-- 2. Projected or fallback DropdownMenu -->

</ng-container>

<ng-template #defaultDropdownButtonsTpl>

  @if (isSplit) {
    <!-- 1. Template splitDefaultButton -->
    @if (splitDefaultButtonTemplate) {
      <ng-container *ngTemplateOutlet="splitDefaultButtonTemplate.tempRef; context: splitDefaultButtonTemplate?.tempContext" />
    } @else {
      <ng-content select="[splitDefaultButton]" />
    }

    <!-- 2. Projected or fallback splitDefaultButton -->
  }

  <button
    appWaves
    appDropdownButton
    [reference]="reference()"
    [split]="isSplit"
    [size]="buttonSize"
    [iconOnly]="IconOnly"
    [variant]="buttonVariant"
    [disabled]="dropdownButtonDisabled"
    [appearance]="buttonAppearance"
    [hideArrow]="hideArrow || IconOnly"
    [attr.class]="dropdownButtonClassStyle"
    [ngClass]="{'me-1': !IconOnly && dropdownButtonIcon && !isGroup, 'btn-icon': IconOnly}">

    @if (dropdownButtonIcon) {
      <i [ngClass]="dropdownButtonIcon"></i>
    }

    @if (!IconOnly) {
      {{dropdownButtonText}}
    }

  </button>

</ng-template>



<!-- start defaultDropdownMenuTpl -->
<ng-template #defaultDropdownMenuTpl let-list="items">
  <ul class="dropdown-menu {{dropdownMenuClassStyle}}">
    @for (item of items; let i = $index; track item?.id ?? i) {
      <ng-container *ngTemplateOutlet="defaultMenuItemTpl; context: { item }" />
    }
    <!-- Footer Template -->
    @let footerTemplate = getTemplate('footerTemplate');

    @if (footerTemplate; as _footerTemplateTpl) {
      <hr class="dropdown-divider">
      <li class="dropdown_item_footer">
        <ng-container *ngTemplateOutlet="_footerTemplateTpl.templateRef; context: _footerTemplateTpl?.context" />
      </li>
    }

  </ul>
</ng-template>


<!-- start defaultMenuTpl -->
<ng-template #defaultMenuItemTpl let-item="item">
  <li [class]="item?.classStyle" [ngStyle]="item?.cssStyle">
    <ng-container *ngTemplateOutlet="menuContent; context: { item }" />
  </li>
</ng-template>


<!-- start menuLinkTemplate  -->
<ng-template #menuContent let-item="item">

  <!-- start ngTemplateOutlet -->
  <ng-container *ngTemplateOutlet="dropdownItemTpl; context: { item }"/>

  <!-- start dropdownItemTemplate -->
  <ng-template #dropdownItemTpl let-noneInteractive="item.noneInteractive" let-routerLink="item.routerLink" let-link="item.link" let-item="item">

    @if (routerLink) {
      <a
        class="dropdown-item"
        [class]="item?.contentClass"
        (click)="commandHandler(item)"
        [fragment]="item?.fragment"
        [routerLink]="item?.routerLink"
        [queryParams]="item?.queryParams"
        [class.disabled]="item?.disabled"
        [routerLinkActive]="item?.routerLinkActive ?? []"
        [queryParamsHandling]="item?.queryParamsHandling ?? null"
        [routerLinkActiveOptions]="item?.routerLinkActiveOptions || {}">
        <ng-container *ngTemplateOutlet="itemContent; context: { item }" />
      </a>
    } @else if (link) {
      <a
        [class]="item?.contentClass" class="dropdown-item"
        (click)="commandHandler(item)"
        [attr.href]="link?.url"
        [attr.target]="link?.target"
        [class.active]="item?.active"
        [class.disabled]="item?.disabled">
        <ng-container *ngTemplateOutlet="itemContent; context: { item }" />
      </a>
    } @else if (noneInteractive) {
      <span [class]="item?.contentClass" class="dropdown-item-text">
        <ng-container *ngTemplateOutlet="itemContent; context: { item }" />
      </span>
    } @else if (item?.isHeader) {
      <h6 class="dropdown-header">
        <ng-container *ngTemplateOutlet="itemContent; context: { item }" />
      </h6>
    } @else {
      <button [class]="item?.contentClass" class="dropdown-item" type="button" (click)="commandHandler(item)" [class.active]="item?.active" [disabled]="!!item?.disabled">
        <ng-container *ngTemplateOutlet="itemContent; context: { item }" />
      </button>
    }

    @if (item?.addDivider) {
      <hr class="dropdown-divider">
    }
  </ng-template>

  <!-- start itemContentTemplate -->
  <ng-template #itemContent let-item="item">
    @if (item?.icon) {
      <i class="me-1" [ngClass]="item?.icon"></i>
    }
    <span class="align-middle">{{item?.label}}</span>
  </ng-template>

</ng-template>
